import { Component, Inject, OnInit } from '@angular/core';
import { AutoEvaluacionComponent } from '../../auto-evaluacion.component';

@Component({
  selector: 'app-autoevaluacion-inicio',
  templateUrl: './autoevaluacion-inicio.component.html',
  styleUrls: ['./autoevaluacion-inicio.component.css']
})
export class AutoevaluacionInicioComponent implements OnInit {


  ngOnInit(): void {
  }
  

}
